import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { InputTableLayoutStepProps } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { CustomRenderString } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import OrderBuyLayout from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout'
import { ColumnOrderTableSchema, OrderData } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { ProductExtendedTyInputTableListing } from '../../../../../../../../../specificComponents/Product/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllSpecificPriceRules, getAllWorkingCenters, getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import BuyOrderCreateStepITHeaderConnect from './BuyOrderCreateStepITHeader'
import useBuyOrderHeaderURLs from '../../../../../../../../../utils/hooks/buys/orders/useBuyOrderHeaderURLsN'
import { BuyOrderStatusInversed } from '@teinor/erp/types/company/order/buy/buyOrder'
import { BuyOrderProductModelTypeExtended } from '@teinor/erp/types/company/order/buy/buyOrder/buyOrderProduct'
import BuyOrderCreateStepHeaderDecider from './BuyOrderCreateHeader'
import { CustomRenderSpecificPrice, CustomRenderPriceWithMargin } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/CustomRenders'


type BuyOrderCreateStepProps = InputTableLayoutStepProps &{ }

const BuyOrderCreateStep: React.FC<BuyOrderCreateStepProps> = ({ inputTableURLs, completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, userPermissions, headerChanges }) => {
    const { t } = useTwinTranslation()
    const workingCenters = getAllWorkingCenters()
    const orderHeaderURLs = useBuyOrderHeaderURLs()
    const specificPriceRules = getAllSpecificPriceRules()
    const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & BuyOrderProductModelTypeExtended> = [
        {
            id: 'nLine',
            dataKey: 'nLine',
            label: t('line', 'Línea'),
            width: 70,
            hideColumnByDefault: true
        },
        {
            id: 'url',
            dataKey: 'url',
            label: t('image', 'Imagen'),
            component: 'ITDisplayImage',
            width: 70
        },
        {
            id: 'code_bar',
            dataKey: 'code_bar',
            label: t('codeBarShort', 'Cod. de barras'),
            component: 'OrderSearchProductInput',
            field: 'code_bar',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
            component: 'OrderSearchSupplierProductInputReference',
            field: 'reference',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 100,
            hideColumnByDefault: true,
            SupplierId: completeData?.header?.SupplierId,
            className: 'quote_order_reference_name'
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            component: 'OrderSearchSupplierProductInputName',
            field: 'name',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
            className: 'quote_order_reference_name'
        },
        {
            id: 'referenceAndName',
            dataKey: 'name',
            label: t('referenceName', 'Referencia y nombre'),
            component: 'OrderSearchSupplierProductInputReferenceAndName',
            field: 'referenceAndName',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 180,
            SupplierId: completeData?.header?.SupplierId,
            className: 'quote_order_reference_name'
        },
        {
            id: 'editProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonSeeProduct', 'Botón de ver producto'),
            component: 'OrderEditProduct',
            width: 35,
            havePermission: permissionCheck(getUserPermissions('product.profile.main'), 'read'),
        },
        {
            id: 'descriptionDocuments',
            dataKey: 'descriptionDocuments',
            label: t('description', 'Descripción'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'shortDescriptionDocuments',
            dataKey: 'shortDescriptionDocuments',
            label: t('shortDescriptionS', 'Desc. corta'),
            simpleLabel: t('shortDescription', 'Descripción corta'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'CopyProduct.name',
            dataKey: 'name',
            label: '',
            simpleLabel: t('editProductName', 'Editar nombre del producto'),
            component: 'ITEditableName',
            typeOnChange: 'onChangeFetch',
            width: 50,
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            component: 'ITEditableText',
            typeOnChange: 'onChangeFetch'
        },
        {
            id: 'supplier_reference',
            dataKey: 'supplier_reference',
            label: t('supplierRefShort', 'Ref. Prov.'),
            simpleLabel: t('supplierRefLong', 'Referencia Proveedor'),
            toolTip: t('supplierRefLong', 'Referencia Proveedor'),
            component: 'ITRectangularInput',
            typeOnChange: 'onChangeFetch',
            width:130,
            hideColumnByDefault: true
        },
        {
            id: 'initialUnitPriceWithoutTax',
            dataKey: 'initialUnitPriceWithoutTax',
            simpleLabel: t('cost', 'Coste'),
            label: () => <div className='text-right w-full mr-10'>{t('cost', 'Coste')}</div>,
            component: 'ITInputPrice',
            typeOnChange: 'onChangeTotalsFetch',
            width: 120,
            sortable: true
        },
        {
            id: 'Product.SpecificPriceRuleId',
            dataKey: 'Product.SpecificPriceRuleId',
            label: (props) => {
                const myValue = parseInt(props.selectedFilterValue || props.value || specificPriceRules?.defaultSpecificPriceRuleId)
                return <span>{t('pvp', 'PVP') + ' (' + (specificPriceRules?.dictionary?.[myValue]?.name || t('notSelectedPriceRule', 'Sin tarifa selec.')) + ')'} </span>
            },
            simpleLabel: t('sellPrice', 'Precio de venta'),
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: specificPriceRules?.dictionary || {}, label: t('specificPriceRule', 'Tarifa') }
            },
            customRender: (parameterValue, allRowData) => <CustomRenderSpecificPrice specificPriceRules={specificPriceRules} allRowData={allRowData} />,
            hideColumnByDefault: true
        },
        {
            id: 'Product.SpecificPriceRuleIdActual',
            dataKey: 'Product.SpecificPriceRuleId',
            label: t('costPriceWithMarginShort', 'PCM'),
            simpleLabel: t('costPriceWithMargin', 'Precio coste con margen'),
            toolTip: t('costPriceWithMargin', 'Precio coste con margen'),
            customRender: (parameterValue, allRowData) => <CustomRenderPriceWithMargin allRowData={allRowData} CurrencyId={completeData?.header?.CurrencyId} />,
            hideColumnByDefault: true
        },
        {
            id: 'margin',
            dataKey: 'margin',
            label: t('margin', 'Margen'),
            component: 'ITInputPercentage',
            typeOnChange: 'onChangeTotalsFetch',
            hideColumnByDefault: true,
            width: 100,
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            component: 'ITInputQuantity',
            typeOnChange: 'onChangeTotalsFetch',
            width: 100,
        },
        {
            id: 'quantity2',
            dataKey: 'quantity2',
            label: t('quantitySecondRes', 'Cant. sec.'),
            simpleLabel: t('quantitySecondary', 'Cantidad secundaria'),
            component: 'ITInputQuantity2',
            width: 100,
            typeOnChange: 'onChangeTotalsFetch',
            hideColumnByDefault: true
        },
        {
            id: 'wasteWeight',
            dataKey: 'wasteWeight',
            label: t('wasteWeight', 'Merma'),
            component: 'ITInputPercentage',
            typeOnChange: 'onChangeTotalsFetch',
            width: 100,
            hideColumnByDefault: true,
            allowEmpty: true
        },
        {
            id: 'calculatedQuantity',
            dataKey: 'calculatedQuantity',
            label: t('quantityCalculatedS', 'Cant. calc.'),
            toolTip: t('quantityCalculated', 'Cantidad calculada'),
            simpleLabel: t('quantityCalculated', 'Cantidad calculada'),
            component: 'ITInputQuantity',
            width: 110,
            typeOnChange: 'onChangeTotalsFetch',
            sortable: true,
            hideColumnByDefault: true,
            readOnlyFnc: () => true
        },
        {
            id: 'unique_number',
            dataKey: 'unique_number',
            label: t('uniqueNumberShort', 'N. único'),
            simpleLabel: t('uniqueNumber', 'Número único'),
            toolTip: t('uniqueNumber', 'Número único'),
            component: 'OrderUniqueNumberProduct',
            hideColumnByDefault: true
        },
        {
            id: 'OrderAccountId',
            dataKey: 'OrderAccountId',
            label: t('chapter', 'Capítulo'),
            component: 'ITInputSelectAccounts',
            accounts: completeData?.header?.OrderAccounts,
            typeOnChange: 'onChangeTotalsFetch',
            minWidth: 110,
            hideColumnByDefault: true
        },
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            component: 'ITInputSelect',
            items: workingCenters?.[completeData?.header?.WorkingCenterId]?.dictWarehouses || {},
            typeOnChange: 'onChangeTotalsFetch',
            minWidth: 110,
            hideColumnByDefault: true,
            readOnly: true
        },
        {
            id: 'discount',
            dataKey: 'discount',
            label: t('discount', 'Descuento'),
            component: 'ITInputDiscount',
            width: 135,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'delivery_date',
            dataKey: 'delivery_date',
            label: t('deliveryEstimated', 'Entrega estimada'),
            component: 'ITInputCalendar',
            width: 160,
            typeOnChange: 'onChangeFetch',
            hideColumnByDefault: true
        },
        {
            id: 'rowPriceWithoutTaxAndTotalDiscount',
            dataKey: 'rowPriceWithoutTaxAndTotalDiscount',
            label: () => <div className='text-right w-full'>{t('costTotal', 'Coste Total')}</div>,
            simpleLabel: t('costTotal', 'Coste Total'),
            component: 'ITDisplayEditFinalPriceBase',
            typeOnChange: 'onChangeTotalsFetch',
            with_vat: false,
            width: 120
        },
        {
            id: 'rowPriceWithTaxAndTotalDiscount',
            dataKey: 'rowPriceWithTaxAndTotalDiscount',
            label: () => <div className='text-right w-full mr-10'>{t('totalCostWithTaxShort', 'Coste Total Imp.')}</div>,
            simpleLabel: t('totalCostWithTaxShort', 'Coste Total Imp.'),
            component: 'ITDisplayEditFinalPriceBase',
            typeOnChange: 'onChangeTotalsFetch',
            with_vat: true,
            width: 145,
            hideColumnByDefault: true,
        },
        {
            id: 'totalWithTaxWithComplements',
            dataKey: 'totalWithTaxWithComplements',
            simpleLabel: t('totalWithComplementsAndVat', 'Total con complementos e imp.'),
            label: () => <div className='text-right w-full' >{t('withComplementsAndVatS', 'Con comp. e imp.')}</div>,
            component: 'ITDisplayPrice',
            width: 160,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplementsAndVatL', 'Total con complementos e impuestos'),
        },
        {
            id: 'totalWithoutTaxWithComplements',
            dataKey: 'totalWithoutTaxWithComplements',
            simpleLabel: t('totalWithComplements', 'Total con complementos'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplements', 'Total con complementos')
        },
        {
            id: 'totalWithoutTaxWithComplementsPrev',
            dataKey: 'totalWithoutTaxWithComplementsPrev',
            simpleLabel: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de desc.'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de descuentos'),
        },
        {
            id: 'unitPriceWithComplements',
            dataKey: 'unitPriceWithComplements',
            simpleLabel: t('unitCostWithComplements', 'Coste unitario con complementos'),
            label: () => <div className='text-right w-full'> {t('unitCwithComplementsS', 'C. U. comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('unitCostWithComplements', 'Coste unitario con complementos'),
        },
        {
            id: 'editAddonProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonAddAddonProduct', 'Botón de añadir complemento'),
            component: 'OrderEditAddonProduct',
            width: 33,
            completeData: completeData,
        },
        {
            id: 'PrintTags',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('printTags', 'Imprimir etiquetas'),
            width: 33,
            component: 'OrderPrintTags',
            hideColumnByDefault: true
        },
        {
            id: 'deleteRow',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('deleteLine', 'Eliminar línea'),
            width: 33,
            component: 'ITDeleteRow',
            requiredColumn: true
        },
        {
            id: 'dragLine',
            dataKey: 'nLine',
            label: '',
            simpleLabel: t('moveLine', 'Mover línea'),
            width: 33,
            component: 'ITDragHandle',
            requiredColumn: true
        },
    ]
    return (
        <OrderBuyLayout modelId='BuyOrderId' name='buyOrderCreateStep' translations={{ headerTitle: t('buyOrder', 'Pedido') }} buttonSave={
            permissionCheck(getUserPermissions('buy.order'), 'update')
                ?
                <BuyOrderCreateStepHeaderDecider orderStatus={completeData?.header.status} OrderLogs={completeData?.header?.OrderLogs} onSubmit={getCompleteData} data={completeData as OrderData} {...{ orderHeaderURLs, setCompleteData, updateHeaderData: inputTableURLs?.updateHeaderData, userPermissions }} />
                : undefined
        } InputTableHeaderChildren={BuyOrderCreateStepITHeaderConnect} {...{ columns, inputTableURLs, orderHeaderURLs, completeData, setCompleteData, getCompleteData, setTableConfiguration, tableConfiguration, userPermissions, headerChanges, orderStatusDict: BuyOrderStatusInversed}
            } />
    )
}


export default BuyOrderCreateStep